module.exports = __webpack_public_path__ + "static/img/day4.9af0acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour4/day4.jpg
// module id = P9vQ
// module chunks = 0